
import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Tag } from "lucide-react";
import { Agent } from "@/models/agent";

interface AgentTagsProps {
  agent: Agent;
}

export const AgentTags: React.FC<AgentTagsProps> = ({ agent }) => {
  if (!agent.tags || agent.tags.length === 0) return null;
  
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {agent.tags.map((tag) => (
        <Badge key={tag} variant="outline" className="hover:bg-primary/10">
          <Tag className="h-3 w-3 mr-1" />
          <Link to={`/category/${encodeURIComponent(agent.category)}?tag=${encodeURIComponent(tag)}`}>
            {tag}
          </Link>
        </Badge>
      ))}
    </div>
  );
};
